import React from "react";
import PropTypes from "prop-types";
import MuiTextField from "@mui/material/TextField";

const TextField = ({
  label,
  innerRef,
  onChange,
  rows,
  ...otherProps
}) => (
    <>
      {label}
      <div className="mgridform-value" style={{ flex: 1, width: rows > 1 ? "100%" : undefined }}>
        <MuiTextField
          ref={innerRef}
          variant="standard"
          onChange={onChange ? (e) => onChange(e.target.value) : undefined}
          multiline={rows > 1}
          rows={rows}
          fullWidth
          {...otherProps}
        />
      </div>
    </>
  );

TextField.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  innerRef: PropTypes.object,
  onChange: PropTypes.func,
  rows: PropTypes.number,
};

export default TextField;